/**
 * A small arrow for a forecast wind, pointing the way the wind BLOWS (downwind), like the windsock beside
 * the readings, so the two read the same way at a glance. `fromDeg` is where the wind comes from, degrees
 * true. Light and variable, or no direction, is a small ring.
 */
export function WindArrow({ fromDeg, size = 26, label }: { fromDeg: number | null; size?: number; label: string }) {
  if (fromDeg === null) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} role="img" aria-label={label} className="warrow">
        <circle cx="12" cy="12" r="6" fill="none" stroke="currentColor" strokeWidth="2" strokeDasharray="3 2" />
      </svg>
    )
  }
  // Pointing down (180°) in the SVG means blowing toward the south; a north wind (from 0°) points down.
  const rotate = (fromDeg + 180) % 360
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} role="img" aria-label={label} className="warrow">
      <g transform={`rotate(${rotate} 12 12)`}>
        <line x1="12" y1="20" x2="12" y2="5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        <polyline points="6.5,10.5 12,4 17.5,10.5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  )
}
